import React from 'react';
import Title from '../../../../../@casino/ui/title';
import Table from '../../../../../@casino/ui/table';
import { useDispatch, useSelector } from 'react-redux';
import { setGetListFreespin } from '../../store/thunk/setGetListFreespin';
import {useRouter} from '../../../../../@casino/useRouter';
import { parseLogin } from '../../../../../@casino/lib/parseLogin';
import { getDate } from '../../../../../@casino/lib/getDate';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20, 
        paddingTop: 0
    },
    wrapBlock: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12,
    },
    searchGamer: {
        padding: 10,
        background: '#141b33',
        paddingLeft: 10,
        border: '1px solid #141b33',
        color: '#fff',
        outline: 'none',
        margin: 10,
        width: '97.3%'
    },
}));

const ListFreespins = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const router = useRouter();

    const [login, setLogin] = React.useState('');

    React.useEffect(() => {
        dispatch(setGetListFreespin({
            page: 1,
            rowsPerPage: 10,
            search: ''
        }))
    }, []);

    const list = useSelector(state => state.freespin.list)

    const columns = [
        { id: 'id', label: 'ID'},
        { id: 'date', label: 'Дата выдачи'},
        { id: 'player_name', label: 'Логин'},
        { id: 'quantity', label: 'Количество'},
        { id: 'freespin_id', label: 'ID freespin'},
        { id: 'game', label: 'Игра'}
    ];


    const rows = list.data.map((item) => {
        return {
            id: item.id,
            date: getDate(item.freespin_id),
            player_name: parseLogin(item.player_name),
            quantity: item.quantity,
            freespin_id: item.freespin_id,
            game: item.game_uuid
        }
    })
    return (
        <div style={{
            padding: '0 20px'
        }}>
        <Title 
            label="Список выданных фриспинов" 
            labelBtn="Выдать" 
            button={() => router.history.push('/freespin/issue')}
            checkLabel="Проверить"
            check={() => router.history.push('/freespin/view')}
        />
            <div className={classes.wrapBlock} style={{padding: 0}}>
                <label htmlFor="search">
                    <input 
                        type="text" 
                        name="search" 
                        id="search" 
                        value={login} 
                        onChange={(v) => {
                            dispatch(setGetListFreespin({
                                page: 1,
                                rowsPerPage: 10,
                                search: v.target.value
                            }))
                            setLogin(v.target.value)
                        }} 
                        className={classes.searchGamer}
                        placeholder="Поиск по логину"
                    />
                </label>
            </div>
            <div style={{
                margin: '12px 0',
                display: 'flex',
                padding: '20px',
                background: '#1b2039',
                alignItems: 'center',
                borderRadius: '8px',
            }}>
                <Table
                    pagination
                    allPage={list.countPage}
                    //width={1300}
                    perPage={10}
                    columns={columns}
                    rows={rows}
                    changePage={(v) => dispatch(setGetListFreespin({
                        page: +v.page+1,
                        rowsPerPage: v.rowsPerPage,
                        search: login,
                    }))}
                    changeRowsPerPage={(v) => dispatch(setGetListFreespin({
                        page: +v.page + 1,
                        rowsPerPage: v.rowsPerPage,
                        search: login,
                    }))}
                />
            </div>
        </div>
    )
}

export default ListFreespins;